import React from 'react'
import { PageElementWrapper } from './src/components/Layout'

// Pass all props (hence the ...props) to the layout component so it has access to things like pageContext or location
export const wrapPageElement = ({ element, props }) => {
  return <PageElementWrapper {...props}>{element}</PageElementWrapper>
}
